import { CanDeactivateFn } from '@angular/router';
import { Observable } from 'rxjs';

type CanDeactivateType = Observable<boolean> | Promise<boolean> | boolean;

export interface IDeactivateComponent {
    canExit: () => CanDeactivateType;
}

export const deactivateGuard: CanDeactivateFn<IDeactivateComponent> = (
    component: IDeactivateComponent
): CanDeactivateType => {
    return component.canExit ? component.canExit() : true;
};
